const axios = require("axios");

const getManuals = async (category = null) => {
  // Construye la URL con el parámetro de categoría si está presente
  const url = `${process.env.GATSBY_API_URL}/api/manuals?product=&code=&manual${category ? `&category=${category}` : ""}`;
  console.log("Fetching manuals from URL:", url);
  
  try {
    const response = await axios.get(url);
    console.log("Manuals fetched:", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching manuals:", error);
  }
};

module.exports = {
  getManuals
};
